import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';

import TextField from '@mui/material/TextField';

import { Container, Separator } from './styles';

function TimerInput({ haveHours, maxMinutes, onSetTime }) {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const onChangeHours = (e) => {
    if (e.target.value > 999) return;
    setHours(e.target.value);
    onSetTime(e.target.value || 0, minutes || 0, seconds || 0);
  };
  const onChangeMinutes = (e) => {
    if (e.target.value > (maxMinutes || 99)) return;
    setMinutes(e.target.value);
    onSetTime(hours || 0, e.target.value || 0, seconds || 0);
  };
  const onChangeSeconds = (e) => {
    if (e.target.value > 100) return;
    setSeconds(e.target.value);
    onSetTime(hours || 0, minutes || 0, e.target.value || 0);
  };

  return (
    <Container>
      {haveHours && (
        <>
          <TextField
            inputProps={{ max: 999 }}
            label={i18n.t('components.timerInput.hours')}
            onChange={onChangeHours}
            type="number"
            value={hours}
            variant="outlined"
          />
          <Separator>:</Separator>
        </>
      )}
      <TextField
        inputProps={{ max: maxMinutes || 99 }}
        label={i18n.t('components.timerInput.minutes')}
        onChange={onChangeMinutes}
        type="number"
        value={minutes}
        variant="outlined"
      />
      <Separator>:</Separator>
      <TextField
        inputProps={{ max: 99 }}
        label={i18n.t('components.timerInput.seconds')}
        onChange={onChangeSeconds}
        type="number"
        value={seconds}
        variant="outlined"
      />
    </Container>
  );
}

TimerInput.propTypes = {
  haveHours: PropTypes.bool,
  maxMinutes: PropTypes.number,
  onSetTime: PropTypes.func,
};

TimerInput.defaultProps = {
  haveHours: false,
  maxMinutes: 99,
  onSetTime: undefined,
};

export default TimerInput;
